// chatclient

import PubNub from 'pubnub';
import randomString from '../utils/random-string';
import { store } from '../store/index';
import {
  addChatMessage,
  setChatMessages,
  setDoctorTyping,
  updateConsults,
  setAppState,
  selectConsult,
  setPastChatMessages,
} from '../actions/index';
import config from '../config';
import { getPubnubToken } from './auth';

const MAX_RETRY_COUNT = 2;
let retryCount = 0;

class ChatClient {
  constructor(pubnub) {
    this.pubnub = pubnub;
  }

  subscribe(channelId) {
    this.pubnub.subscribe({
      channels: [channelId],
      // channelGroups: [channelId],
      withPresence: true,
    });
    this.messageListener = this.addMessageListener((payload) => {
      store.dispatch(addChatMessage(payload));
    });
    this.presenceListener = this.addPresenceListener(
      (action, channelName, occupany, state) => {
        if (action === 'state-change') {
          if (state.status === 'USER_TYPING') {
            store.dispatch(setDoctorTyping(true, state.patientId));
          } else if (state.status === 'USER_STOP_TYPING') {
            store.dispatch(setDoctorTyping(false, null));
          }
        }
      }
    );
    this.statusListener = this.addStatusListener((category, operation) => {
      const { consults } = store.getState();
      switch (category) {
        case 'PNNetworkDownCategory':
          this.unsubscribe(consults.unrepliedChannel);
          break;
        case 'PNNetworkUpCategory':
          this.subscribe(consults.unrepliedChannel);
          store.dispatch(updateConsults());
          store.dispatch(selectConsult(consults.activeConsult));
          break;
        default:
          break;
      }
    });
  }

  unsubscribe(channelId) {
    console.log(
      this.pubnub.unsubscribe({
        channels: [channelId],
      })
    );
    this.removeListener(this.messageListener);
    this.removeListener(this.presenceListener);
  }

  addMessageListener(fnc) {
    const listener = {
      message: (m) => {
        console.log({ m }, 'new message');
        const { user, chat, consults } = store.getState();
        const channelName = m.channel; // The channel for which the message belongs
        // The channel group or wildcard subscription match (if exists)
        const channelGroup = m.subscription;
        const pubTT = m.timetoken; // Publish timetoken
        const payload = m.message; // The Payload
        // Pass the payload to handler in case it is not from user, or it is an image or document payload
        const shouldParseMessage =
          payload.senderId.toString() !== user.doctorId.toString() ||
          payload.cardType === 'chatImage' ||
          payload.cardType === 'documentCard' ||
          payload.cardType === 'prescriptionCard' ||
          payload.cardType === 'treatmentPlanCard' ||
          payload.cardType === 'sp-suggest' ||
          payload.cardType === 'reschedule-card';
        console.log({ m, shouldParseMessage }, 'new message');

        if (shouldParseMessage) {
          if (window.newMsgAudioBuffer && window.audioContext) {
            const soundSource = window.audioContext.createBufferSource();
            soundSource.buffer = window.newMsgAudioBuffer;
            soundSource.connect(window.audioContext.destination);
            soundSource.start();
          }
          if (channelName === chat.chatChannel) {
            // Add message to redux store
            payload.timetoken = Number.parseFloat(m.timetoken) / 10000;
            fnc(payload, channelName, channelGroup, pubTT);
          } else {
            // new message arrived from different consultation, update consultation list
            store.dispatch(updateConsults());
          }
        }
      },
    };
    this.pubnub.addListener(listener);
    return listener;
  }

  addStatusListener(fnc) {
    // handle status
    this.pubnub.addListener({
      status: (s) => {
        const {
          category,
          operation,
          affectedChannels,
          subscribedChannels,
          affectedChannelGroups,
          lastTimetoken,
          currentTimetoken,
        } = s;

        fnc(
          category,
          operation,
          affectedChannels,
          subscribedChannels,
          affectedChannelGroups,
          lastTimetoken,
          currentTimetoken
        );
      },
    });
  }

  addPresenceListener(fnc) {
    this.pubnub.addListener({
      presence: (p) => {
        // handle presence
        const {
          action,
          channelName,
          occupancy,
          state,
          channelGroup,
          presenceEventTime,
          uuid,
        } = p;

        fnc(
          action,
          channelName,
          occupancy,
          state,
          channelGroup,
          presenceEventTime,
          uuid
        );
      },
    });
  }

  removeListener(fnc) {
    this.pubnub.removeListener(fnc);
  }

  setState(status, doctorId) {
    console.log({ status, doctorId }, 'setState method called');
    const { chat } = store.getState();
    const channel = chat.chatChannel;
    this.pubnub.setState(
      {
        channels: [channel],
        state: {
          doctorId,
          status,
        },
      },
      (status, response) => {
        if (status.error) {
          // Handle error
          console.log(status);
          return;
        }
        console.log({ response });
      }
    );
  }

  publish(message) {
    const { chat, consults } = store.getState();
    console.log(message);
    const channel = chat.chatChannel;
    const unrepliedChannel = consults.unrepliedChannel;
    const chatMessage = this.createChatMessage(message);
    store.dispatch(addChatMessage(chatMessage));

    console.log('Publishing message', { chatMessage });

    this.pubnub.publish(
      {
        message: chatMessage,
        channel,
      },
      (status, response) => {
        if (status.error) {
          // Handle error
          console.log(status);
          return;
        }
        const { chat } = store.getState();
        chat.chatMessages.forEach((ele) => {
          // console.log(ele, chatMessage);
          if (ele.messageId === chatMessage.messageId) {
            chatMessage.timetoken =
              Number.parseFloat(response.timetoken) / 10000;
          }
        });
        store.dispatch(setChatMessages(Array.from(chat.chatMessages)));
      }
    );
    this.pubnub.publish(
      {
        message: chatMessage,
        channel: unrepliedChannel,
      },
      (status, response) => {
        if (status.error) {
          // Handle error
          console.log(status);
          return;
        }
        console.log(
          { response, unrepliedChannel },
          'publishing on unreplied channel'
        );
      }
    );
    // Publish to doctor inbound channel
    // this.pubnub.publish({
    //   message: chatMessage,
    //   channel: `visit-inbound-doctor-${doctorId}`,
    // }, (status, response) => {
    //   if (status.error) {
    //     console.log('Doctor channel', status);
    //   }
    //   console.log('Doctor channel', response);
    // });

    return chatMessage;
  }

  createChatMessage(message) {
    const { user, consults } = store.getState();
    const chatMessage = {
      senderId: user.doctorId,
      consultationId: parseInt(consults.activeConsult.consultationId),
      name: `${user.doctorFirstName}`,
      messageId: randomString(20),
      platform: 'web-sdk',
      text: message.text || '',
      userType: 'doctor',
      notificationType: 'chat',
      type: 'chat',
      cardType: message.cardType || 'text',
      messageType: message.messageType,
      ...message,
    };

    // Add notification payload
    const basePayloadCopy = Object.assign({}, chatMessage);
    chatMessage.pn_apns = {
      aps: {
        ...basePayloadCopy,
        sound: 'default',
        alert: {
          title: basePayloadCopy.name,
          body: basePayloadCopy.text || 'New Message',
        },
        topic: 'com.getvisitapp.visit',
      },
    };

    chatMessage.pn_gcm = {
      data: basePayloadCopy,
    };

    return chatMessage;
  }

  // [1,2,3,4,5]

  // check if historical messages length < batch size then increase the channel index

  history(options) {
    const { chat } = store.getState();
    return this.executeWithRetry(
      () =>
        new Promise((resolve, reject) => {
          this.pubnub.history(options, (status, res) => {
            if (!status.error) {
              const { chatMessages } = chat;
              const historicalMessages = res.messages;
              const formattedMessages = [];
              historicalMessages.forEach((message) => {
                formattedMessages.push({
                  timetoken: message.timetoken / 10000,
                  ...message.entry,
                });
              });
              console.log(formattedMessages);
              store.dispatch(
                setChatMessages(formattedMessages.concat(chatMessages))
              );
              resolve();
            } else {
              console.log('History err', status, res);
              reject(status);
            }
          });
        }),
      'history',
      options
    ).catch((error) => {
      console.error('Failed to fetch history after retries:', error.message);
      return { error: error.message };
    });
  }

  getNextHistoryBatch(currentChannelId, oldestTimeToken) {
    const { chat } = store.getState();
    const options = {
      channel: currentChannelId,
      count: 30,
      start: oldestTimeToken,
    };
    console.log(options);
    return new Promise((resolve, reject) => {
      this.pubnub.history(options, (status, res) => {
        if (!status.error) {
          const { pastChatMessages } = chat;
          const historicalMessages = res.messages;
          const formattedMessages = [];
          historicalMessages.forEach((message) => {
            formattedMessages.push({
              timetoken: message.timetoken / 10000,
              ...message.entry,
            });
          });
          console.log(formattedMessages);
          store.dispatch(
            setPastChatMessages(formattedMessages.concat(pastChatMessages))
          );
          console.log(formattedMessages);
          // Resolve with the formatted messages
          resolve(formattedMessages);
        } else {
          console.log(status);
          reject(status);
        }
      });
    });
  }

  async executeWithRetry(fn, method, ...args) {
    let localRetryCount = 0;
    const { chat } = store.getState();
    const errors = [];

    while (localRetryCount < MAX_RETRY_COUNT) {
      try {
        return await fn(); // Attempt the PubNub operation
      } catch (error) {
        errors.push(error);
        if (error.statusCode === 403) {
          console.warn(
            `403 Forbidden in ${method} - Attempting to refresh token and retry... (${
              localRetryCount + 1
            }/${MAX_RETRY_COUNT})`
          );
          localRetryCount++;
          try {
            const newToken = await getPubnubToken(chat.consultationId, 'OC'); // Fetch new token
            this.pubnub.setToken(newToken); // Update with setToken for v7.x
            this.pubnub.reconnect();
            await new Promise((resolve) => setTimeout(resolve, 1000)); // Add a brief delay
            continue; // Retry the operation
          } catch (tokenError) {
            console.error('Failed to refresh token', tokenError);
            throw tokenError; // Propagate token refresh error
          }
        } else {
          throw error; // Propagate non-403 errors
        }
      }
    }

    const error = new Error(
      `Max retry limit reached for ${method} after ${MAX_RETRY_COUNT} attempts.`
    );
    error.originalErrors = errors; // Attach original errors for debugging
    throw error;
  }
}

let client = null;
let currentConsultId = null;

const initializeChatClient = async (consultId) => {
  // Check if we already have a client for this consultId
  const { user } = store.getState();
  if (client && currentConsultId === consultId) {
    // Return existing client if consultId hasn't changed
    return client;
  }

  // Clean up existing client if there is one
  if (client) {
    try {
      client.pubnub.unsubscribe({
        channels: [consultId],
      });
      // Also properly remove listeners
      if (client.messageListener)
        client.pubnub.removeListener(client.messageListener);
      if (client.presenceListener)
        client.pubnub.removeListener(client.presenceListener);
      if (client.statusListener)
        client.pubnub.removeListener(client.statusListener);
    } catch (error) {
      console.warn('Error cleaning up existing chat client:', error);
    }
    client = null;
  }

  // Create new client with fresh token
  const token = await getPubnubToken(consultId, 'OC');

  const pubnubParams = {
    subscribeKey: config.pubnubSubscribeKey,
    publishKey: config.pubnubPublishKey,
    uuid: user.doctorUuid,
    token: token,
  };

  const pubnub = new PubNub(pubnubParams);
  client = new ChatClient(pubnub);
  // Store the current consultId for future reference
  currentConsultId = consultId;

  return client;
};
export { initializeChatClient };
